export default __webpack_public_path__ + "media/images/images/banner/banner-10-60cec747ae5cd4226977c8d6ee42e0c4.jpg";